import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0f0a3bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dates-grid" }
const _hoisted_2 = { class: "dates-grid__grid" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "week-cell__container"
}
const _hoisted_5 = { class: "week-cell" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "dates-grid__week-divider"
}

import { computed } from "vue";
import { generateDateViewCells } from "../../generators";
import { WeekDaysHeader } from "../week-days-header";
import { modifyDate } from "../../utils";
import { DateViewCell } from "../../types";


export default /*#__PURE__*/_defineComponent({
  __name: 'dates-grid',
  props: {
  /**Выбранная дата */
  modelValue: { type: Date },
  /**Включить режим выбора недели */
  isWeek: { type: Boolean, default: false },
  /**Отображаемый год */
  viewYear: { type: Number, required: true },
  /**Отображаемый месяц */
  viewMonth: { type: Number, required: true },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





/**Ячейки */
const rows = computed(() =>
  generateDateViewCells(props.viewYear, props.viewMonth)
);
/**Временная метка */
const timestamp = computed(
  () =>
    props.modelValue && modifyDate(props.modelValue).clearTime("hour").getTime()
);

/**
 * * Проверить выбрана ли неделя
 * @param cell Ячейка
 */
const isSelectedWeek = (cells: DateViewCell[]) => {
  return cells.some(
    (cell) => props.modelValue && timestamp.value === cell.timestamp
  );
};

const onSelectCell = (cell: DateViewCell) => {
  let date = new Date(cell.date);
  if (props.modelValue)
    date.setHours(
      props.modelValue.getHours(),
      props.modelValue.getMinutes(),
      props.modelValue.getSeconds(),
      props.modelValue.getMilliseconds()
    );
  if (props.isWeek) {
    date = modifyDate(date).getMonday();
  }
  emit("update:modelValue", date);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(WeekDaysHeader), {
      class: "dates-grid__header",
      "show-week-num-title": __props.isWeek
    }, null, 8, ["show-week-num-title"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([
          'dates-grid__row',
          {
            'is-select-week': __props.isWeek,
            'is-selected': __props.isWeek && isSelectedWeek(row),
          },
        ]),
          onClick: ($event: any) => (onSelectCell(row[0]))
        }, [
          (__props.isWeek)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "week-cell", {
                  weekNum: row[0].weekNum
                }, () => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(row[0].weekNum), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "date-cell__container",
              key: cell.timestamp,
              onClick: _withModifiers(($event: any) => (onSelectCell(cell)), ["stop"])
            }, [
              _renderSlot(_ctx.$slots, "cell", { cell: cell }, () => [
                _createElementVNode("div", {
                  class: _normalizeClass([
                'date-cell',

                {
                  'no-current': cell.offsetMonth !== 'current',
                  'is-today': cell.isCurrent,
                  'is-weekend': cell.isWeekend,
                  'is-selected': cell.timestamp === timestamp.value,
                },
              ])
                }, _toDisplayString(cell.text), 3)
              ])
            ], 8, _hoisted_6))
          }), 128))
        ], 10, _hoisted_3))
      }), 256))
    ]),
    (__props.isWeek)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}
}

})